import React from 'react';
import { MessageHeader } from '../components/organisms/Message/MessageHeader';
import { MessageBody } from '../components/organisms/Message/MessageBody';
import { Flex } from '@chakra-ui/react';

export const SendMessage: React.FC = () => {
  return (
    <>
      <Flex direction='column' h='100vh'>
        <MessageHeader />
        <MessageBody />
      </Flex>
    </>
  );
};
